import graphql__70527df9691e650730fd from "./__generated__/AnswerBudget_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import BudgetField from "../Form/Field/BudgetField";

const AnswerBudget = props => {
  const { answers, formField } = useFragment(AnswerBudget_answer, props.answer);

  const {
    fieldName,
    label,
    required,
    hint,
    hintPosition,
    hide,
    goal,
    unit,
    minAmount,
    maxAmount
  } = formField;

  return (
    <BudgetField
      answers={answers}
      formField={formField}
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      goal={goal}
      unit={unit}
      minAmount={minAmount}
      maxAmount={maxAmount}
    />
  );
};

const AnswerBudget_answer = graphql__70527df9691e650730fd;

export default AnswerBudget;
